import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import EstimatedPriceEntry from './pages/EstimatedPriceEntry'
import EstimatedPriceResult from './pages/EstimatedPriceResult'
import HomePage from './pages/HomePage'
import IosPage from './pages/IosPage'
import SchatzpreisPage from './pages/SchatzpreisPage'
import VehicleDetailsPage from './pages/VehicleDetailsPage'
import EmailConfirmPage from './pages/EmailConfirmPage'

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/estimated-price-entry" element={<EstimatedPriceEntry />} />
      <Route path="/estimated-price-result" element={<EstimatedPriceResult />} />
      <Route path="/ios" element={<IosPage />} />
      <Route path="/schatzspreis" element={<SchatzpreisPage />} />
      <Route path="/fahrzeug-details" element={<VehicleDetailsPage />} />
      <Route path="/email-confirm" element={<EmailConfirmPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
